import React, { Fragment } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { ACTIONS, getNews, readNews } from './../../../actions/news';
import { getNotification } from './../../../actions/notification';
import Loading from '../../../components/loading';
import Pagination from '../../../components/pagination';
import './styles.scss';

class News extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isShowDropdown: false,
            listNews: [],
            contentNew: '',
            timeNew: '',
            showLoading: false,
            meta: null,
            per_page: null,
            total: null,
            currentId: null,
            showPagination: true,
        }
    }

    componentDidMount() {
        this.setState({ showLoading: true });
        const { search } = this.props.location;
        const param = queryString.parse(search);
        if (!search) {
            this.props.history.push(`/news?keyword=&page=1`);
        } else {
            this.props.history.push(`/news?keyword=${param.keyword}&page=${param.page}`);
        }
        const data = {
            keyword : param.keyword || '',
            page : param.page || 1
        }

        this.props.getNews(data);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_DATA_NEWS_SUCCESS) {
                let data = nextProps.response.data;
                const meta = nextProps.response.meta;
                if (data.length > 0) {
                    this.setState({
                        showLoading: false,
                        listNews: nextProps.response.data,
                        per_page: meta.per_page,
                        total: meta.last_page,
                        showPagination: true,
                    })
                } else {
                    this.setState({
                        showLoading: false,
                        showPagination: false,
                        listNews: nextProps.response.data,
                    })
                }


                if (!this.state.currentId && nextProps.response.data) {
                    let viewIdx = nextProps.response.data.findIndex((item) => {
                        return item.is_unread;
                    })
                    viewIdx = (viewIdx != -1) ? viewIdx : (nextProps.response.data[0]) ? 0 : -1;
                    if (viewIdx != -1) {
                        this.showContentNews(nextProps.response.data[viewIdx]);
                    }
                }
            }
        }
    }

    getItemsPage(e) {
        this.setState({ showLoading: true });

        const { search } = this.props.location;
        const param = queryString.parse(search);

        const data = {
            keyword : param.keyword || '',
            page : e || 1
        }

        this.props.getNews(data);
        this.props.history.push(`/news?keyword=${data.keyword}&page=${data.page}`);

    }

    showContentNews(item) {
        this.props.readNews(item.id);
        this.props.getNotification();
        const elem = document.getElementById('unread-' + item.id);
        elem && elem.parentNode.removeChild(elem);

        this.setState({
            currentId: item.id,
            contentNew: item.content,
            timeNew: item.opened_at
        })
    }

    render() {
        return (
            <Fragment>
                <div className="wrapper-content delivery-wrapper-news w-100 justify-content-start">
                    <div className="delivery w-42">
                        <div className="title w-100 d-inline-flex align-items-center font-weight-bold">
                            <h3>データスタジアムからのお知らせ</h3>
                        </div>
                        <div className="delivery-table w-100 ">
                            <div className="table-wrapper">
                                <table className="w-100 pt-1">
                                    <tbody>
                                        {
                                            this.state.listNews.length
                                                ?
                                                    this.state.listNews.map((value, index) => {
                                                        return (
                                                            <tr key={index} onClick={() => this.showContentNews(value)} >
                                                                <td className="w-100 flex-column justify-content-between align-items-center   none-border ">
                                                                    <div className="h-100 w-100 justify-content-between ">
                                                                        {
                                                                            value.is_unread
                                                                                ? <div className="note-dot mr-1" id={'unread-' + value.id } />
                                                                                : null
                                                                        }
                                                                        <div className="d-inline-flex justify-content-start align-items-center">
                                                                            <div className="mr-1 info">
                                                                                <div className="">
                                                                                    <h4 className="" >{value.content.length > 50 ? value.content.slice(0,50) + '...' : value.content}</h4>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="date h-100 ">
                                                                            <div className="d-inline-flex justify-content-end align-items-center">
                                                                                <div className="mr-1">公開日時：</div>
                                                                                <div>{ moment(value.opened_at).format('YYYY/MM/DD HH:mm') }</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                : null
                                        }
                                    </tbody>
                                </table>
                                {this.state.showPagination && <Pagination
                                    items={this.props.data}
                                    pageSize={this.state.per_page}
                                    totalPages={this.state.total}
                                    onChangePage={(e) => this.getItemsPage(e)}
                                    // showPagination={this.state.showPagination}
                                />}
                            </div>
                        </div>
                    </div>
                    <div className="wrap-work-space">
                        <div className="work-space w-58">
                            <div className="title flex-row align-items-center justify-content-between ">
                                {/* <div className="content align-middle">内容テキスト内容テキスト内容テキスト内容テキ...</div> */}
                                <div className="date flex-column align-items-flex-end justify-content-end">
                                    <div className="delivery-date  flex-row justify-content-end align-items-center">
                                        {
                                            this.state.timeNew
                                            ? <><div className="mr-1">公開日時：</div>
                                            <div>{ moment(this.state.timeNew).format('YYYY/MM/DD HH:mm') }</div></>
                                            : ''
                                        }
                                    </div>
                                </div>
                            </div>

                            <div>
                                { this.state.contentNew }

                        </div>
                        </div>


                    </div>
                </div>

                <Loading show={this.state.showLoading} />
            </Fragment>
        )
    }
}
const mapStateToProps = ({ news }) => {
    return {
        data: news.data,
        status: news.status,
        response: news.response
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getNews: (data) => {
            dispatch(getNews(data))
        },
        readNews: (data) => {
            dispatch(readNews(data))
        },
        getNotification: () => dispatch(getNotification()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(News);
